import React from "react";

const NoResultsFound = () => {
  return <div className="no-result-found"></div>;
};

export default NoResultsFound;
